//import Libraries
import React from 'react';

//import Components
import {Container} from 'reactstrap';

//import Styles

const loading = (props) => {
    return (
        <Container>
            <div>
                <h1>{props.text}</h1>
            </div>
            <div>
                Loading ....
            </div>
        </Container>
    );
}

export default loading;


// WEBPACK FOOTER //
// ./src/components/Loading/Loading.js